(ns dre.components.form
  (:require
   ["antd" :refer [Form]]))

(defn form
  [props content]
  [:> Form
   props
   content])

(defn form-item
  [props content]
  [:> Form.Item
   props
   content])
